/**
 * Interface scale (Settings → Styling): the whole app drawn larger or smaller.
 * `#root` carries `zoom: var(--om-ui-scale)` (index.css), so the console
 * pages, the shell and the embedded CRM frame scale together; the value is
 * set on <html> here and before the first paint (index.html).
 *
 * Under CSS zoom, pointer and getBoundingClientRect() coordinates are on the
 * screen, while lengths written inside #root are multiplied by the scale.
 * Code that turns a screen position into a left/top/scroll/translate inside
 * the app divides by uiScale(). Menus and dialogs portalled to <body> sit
 * outside the zoom and need nothing.
 */
import { CRM_UI_SCALE } from '../crm/crmStyling';

let current = 1;

/** The scale in use (1 = 100%). */
export function uiScale(): number {
  return current;
}

/** A screen length (pointer or getBoundingClientRect) as a length inside the zoomed app. */
export function inApp(screenPx: number): number {
  return screenPx / current;
}

/** The factor for a saved setting: Default on, or nothing saved, is 100%. */
export function scaleFactor(percent: number, useDefault: boolean): number {
  if (useDefault || !Number.isFinite(percent)) return 1;
  return Math.max(CRM_UI_SCALE.min, Math.min(CRM_UI_SCALE.max, percent)) / 100;
}

export function applyUiScale(factor: number, root: HTMLElement = document.documentElement): void {
  current = factor;
  if (factor === 1) root.style.removeProperty('--om-ui-scale');
  else root.style.setProperty('--om-ui-scale', String(factor));
}
